export default "/images/circle-mask.svg?53ceb38e1dc3378057c3454f3437ec64";